import { red, yellow } from '@mui/material/colors'
import React, { useCallback, useEffect, useState, useRef, useContext, useMemo } from 'react'
import brokerApi from '../../../api/brokerApi';
import helper from '../../../helper';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { RHFAutocomplete } from '../../../Components/RHFAutocomplete';
import { Box, Button, Container, Grid, IconButton, Paper, Typography } from '@mui/material';
import RtlProvider from '../../../Components/RtlProvider';
import reservationApi from '../../../api/reservationApi';
import { ContextUserInfo } from '../MainPanel';
import cityApi from '../../../api/cityApi';
import planAttachmentApi from '../../../api/planAttachmentApi';

import Base64Downloader from 'common-base64-downloader-react'
import { MdDownload } from "react-icons/md";
import brokerGroupApi from '../../../api/brokerGroupApi';
import {
    MaterialReactTable,
    useMaterialReactTable,
} from 'material-react-table';
import staticVariablesApi from '../../../api/staticVariablesApi';

const PlanAttachmentList = () => {
    const { userInfo, userPermissions, userRoles } = useContext(ContextUserInfo);
    const [Cities, SetCities] = useState([]);
    const [Brokers, SetBrokers] = useState([]);
    const [GroupNumbers, setGroupNumbers] = useState([]);
    // const [tripGroupId, setTripGroupId] = useState(null)
    // const [rows, setRows] = useState([]);
    const [data, setData] = useState([])
    const [refresh, setRefresh] = useState(false);
    const [loadingRows, setLoadingRows] = useState(false);


    const schema = yup.object().shape({
        brokerId: yup.string().required("کارگزار را انتخاب نمایید"),
        groupNumber: yup.string().required("گروه را انتخاب کنید"),
    });
    const { register, setValue, handleSubmit, formState: { errors }, control, resetField, watch } = useForm({
        resolver: yupResolver(schema),
    });
    const brokerId = watch('brokerId');
    const groupId = watch("groupNumber");
    const onSubmit = (data) => {
        GetData(groupId, data?.CityConsistency)
    }
    useEffect(() => {
        GetBrokerDropDown(userInfo);
        GetCityDropDown();
    }, [])
    useEffect(() => {

    }, []);

    const GetData = (groupId, cityConsistency) => {
        setLoadingRows(true);
        planAttachmentApi.GetHotelAttachmentsByGroupId(groupId, parseInt(cityConsistency))
            .then(res => {
                setData(res.data.data.hotelAttachmentRead)
            }).catch(err => {
                console.log(err)
            }).finally(() => setLoadingRows(false));
    }

    const GetBrokerDropDown = (userInfo) => {

        if (userInfo?.brokerNo) {
            brokerApi.GetByBrokerCode(userInfo.brokerNo).then(res => {
                const kargozar = [];
                kargozar.push(res.data.data)
                SetBrokers(kargozar.map((r) => {
                    return {
                        id: r.id,
                        label: r.name + "-" + r.code
                    };
                }));
                setValue('brokerId', res.data.data.id)
                GetSelectedBrokerGroupNumbers(res.data.data.id)
            }).catch(err => {
            })
        }
        else {
            brokerApi
                .BrokerDropDown()
                .then((res) => {
                    const arr = helper.DictionayToList(res.data.data)
                    SetBrokers(arr.map((r) => {
                        return {
                            id: r.key,
                            label: r.value
                        };
                    }))
                })
                .catch((error) => console.log(error));
        }
    };
    const handleBrokerChanged = useCallback(async (id) => {
        resetField("groupNumber");
        setGroupNumbers(null);
        if (id) {
            const groupNumbers = await fetchGroupNumbersByBrokerId(id);
            setGroupNumbers(
                groupNumbers.map((o) => {
                    return {
                        id: o.key,
                        label: o.value
                    };
                })
            );
        }
    }, [])
    const handleGroupNumberChanged = (id) => {
        // if (id) {
        //     setTripGroupId(id);
        // }

    }
    const fetchGroupNumbersByBrokerId = async (brokerId) => {
        try {
            let res = await brokerGroupApi.BrokerGroupDropDown(brokerId)
            if (res.status == 200) {
            }
            const arr = helper.DictionayToList(res.data.data)
            return arr;
        }
        catch (err) {
            console.error(err);
        }
    };
    const GetSelectedBrokerGroupNumbers = (brokerId) => {
        try {
            brokerGroupApi.BrokerGroupDropDown(brokerId).then(res => {
                const groupNumbers = helper.DictionayToList(res.data.data)
                setGroupNumbers(
                    groupNumbers.map((o) => {
                        return {
                            id: o.key,
                            label: o.value
                        };
                    })
                );
            }).catch(err => {
            });

        }
        catch (err) {
            console.error(err);
        }
    };
    const GetCityDropDown = () => {
        staticVariablesApi.GetArabicCityConsistencyDropDown()
            .then((res) => {
                const arr = helper.DictionayToList(res.data.data)
                const mappedReponse = arr.map((r) => {
                    return {
                        id: r.key,
                        label: r.value
                    };
                });
                SetCities(mappedReponse);
            })
            .catch((error) => console.log(error));
    };
    const handleCityChanged = (id) => { };
    const RefreshGrid = (result) => {
        if (result)
            setRefresh(old => !old);
    }

    const columns = useMemo(
        () => [
            {
                accessorKey: 'hotelName',
                header: 'نام هتل',
                size: 100,
            },
            {
                accessorKey: 'color',
                id: 'color',
                header: 'دانلود',
                size: 150,
                Cell: ({ cell, row }) => (
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                        {row.original.hotelFiles.map((file) => (

                            <Box key={file.id} sx={{ height: 37, mt: 2 }}>
                                <Box sx={{ display: 'flex', justifyItems: 'center', justifyContent: 'center', alignItems: 'center', alignContent: 'center' }}>
                                    <Box>{file.fileName}</Box>
                                    <Base64Downloader
                                        base64={'data:' + file.contentType + ";base64," + file.base64File}
                                        downloadName={file.fileName}
                                        Tag="a"
                                        extraAttributes={{ href: '#' }}
                                        className="my-class-name"
                                        style={{ color: 'black' }}
                                        onDownloadSuccess={() => { }}
                                        onDownloadError={() => { }}
                                    >
                                        {
                                            <IconButton>
                                                <MdDownload color="inherit" size="20px" />
                                            </IconButton>
                                        }
                                    </Base64Downloader>
                                </Box>
                            </Box>

                        ))
                        }
                    </Box>
                ),
                enableSorting: false,
            },


        ],
        [],
    );

    const table = useMaterialReactTable({
        columns,
        data,
        initialState: {
            sorting: [

            ],
        },
        state: {
            isLoading: loadingRows,
        },
        enableRowSelection: false,
        enableTopToolbar: false,
        enableBottomToolbar: false,
        enablePagination: false,
        enableSorting: true,
        enableColumnActions: false,

        mrtTheme: (theme) => ({
            baseBackgroundColor: theme.palette.background.default, //change default background color
        }),

        muiTableProps: {
            sx: {
                border: '1px solid rgba(81, 81, 81, .5)',

            },
        },
        muiTableHeadCellProps: {
            sx: {
                border: '1px solid rgba(81, 81, 81, .5)',
                backgroundColor: '#86A7FC',
                fontWeight: 'bold',
                textAlign: 'left'
            },
        },
        muiTableBodyCellProps: {
            sx: {
                border: '1px solid rgba(81, 81, 81, .5)',
                textAlign: 'left'
            },
        },
        enableRowActions: true,
        positionActionsColumn: 'last',
        displayColumnDefOptions: {
            'mrt-row-actions': {
                header: '', //change header text
                size: 300, //make actions column wider

            },
        },
        renderRowActions: ({ row, table }) => (

            <Box sx={{ display: 'flex', flexWrap: 'nowrap', gap: '8px' }}>


            </Box>
        ),
    });

    return (
        <Container component="main">
            <form onSubmit={handleSubmit(onSubmit)}>
                <RtlProvider>
                    <Typography component="h1" variant="h5" mb={2}>
                        پلان مهندسی
                    </Typography>
                    <Grid container spacing={1} sx={{ mb: 2 }}>
                        <Grid item xs={12} sm={3}>
                            <RHFAutocomplete
                                loading={!Brokers?.length}
                                control={control}
                                options={Brokers ?? []}
                                name="brokerId"
                                placeholder="کارگزار"
                                onChange={handleBrokerChanged}
                                error={!!errors?.brokerId}
                                helperText={errors?.brokerId?.message}
                            />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <RHFAutocomplete
                                control={control}
                                options={Cities ?? []}
                                name="CityConsistency"
                                placeholder="شهر"
                                onChange={handleCityChanged}
                                style={{
                                    border: "none",
                                    padding: 0
                                }}
                            />

                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <RHFAutocomplete
                                control={control}
                                options={GroupNumbers ?? []}
                                name="groupNumber"
                                placeholder="گروه"
                                onChange={handleGroupNumberChanged}
                                error={!!errors?.groupNumber}
                                helperText={errors?.groupNumber?.message}
                            />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <Button type="submit" variant="contained" color="secondary">جستجو</Button>
                        </Grid>
                    </Grid>
                    <MaterialReactTable table={table} />
                </RtlProvider>
            </form>
        </Container>
    )
}

export default PlanAttachmentList